import { SalesforceEnv, salesforceConfigs } from './salesforceConfigs';

declare global {
  interface Window {
    embeddedservice_bootstrap: any;
  }
}

// Initializes the Salesforce chat with the provided email and environment
export const initSalesforceChat = (environment: string = 'test') => {
  if (!window.embeddedservice_bootstrap) {
    console.error('Embedded service is not defined');
    return;
  }

  const { orgId, deploymentName, baseUrl, scrt2URL, storageDomain } = salesforceConfigs[environment as SalesforceEnv];
  try {
    window.embeddedservice_bootstrap.settings.language = 'en_US';
    window.embeddedservice_bootstrap.settings.storageDomain = storageDomain;
    window.embeddedservice_bootstrap.settings.chatButtonPosition = '155px, 12px';

    window.embeddedservice_bootstrap.init(orgId, deploymentName, baseUrl, {
      scrt2URL,
    });

    window.addEventListener('onEmbeddedMessagingReady', () => {
      window.embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
        FirstName: {
          value: ['FirstName__c'],
          isEditableByEndUser: true,
        },
        LastName: {
          value: ['LastName__c'],
          isEditableByEndUser: true,
        },
        Email: {
          value: ['Email__c'],
          isEditableByEndUser: true,
        },
      });
    });
  } catch (err) {
    console.error('Error loading Embedded Messaging: ', err);
  }
};
